import isEmpty from 'lodash/isEmpty';
import { executeRules, hasProductPricing, productDimensions } from '../../../../api/autobahn';
import buildPayloadForPrice from '../../../../helpers/buildPayloadForPrice';

const dimensions = {
  check: async (sourceItem, targetItem) => {
    function filterChoices(choices) {
      return choices.filter(choice => ![1, 2].includes(choice.optionId))
        .map(choice => ({
          C: choice.choiceId,
          O: choice.optionId,
          CV: choice.choiceValue,
        }));
    }
    function addHeightOrWidthAttributes(attributes) {
      return attributes.filter(attr => ['height', 'width'].includes(attr.name.toLowerCase()))
        .map((attr) => {
          const attrNameLower = attr.name.toLowerCase();
          return {
            C: attrNameLower === 'height' ? 1 : 2,
            O: attrNameLower === 'height' ? 1 : 2,
            CV: attr.value,
          };
        });
    }
    let payload = [];
    let heightOrWidthAttributes;
    const { choices } = sourceItem.itemProduct;
    const hasItemProducts = !isEmpty(targetItem.itemProducts);
    const hasAttributes = isEmpty(targetItem.attributes);
    if (hasItemProducts || (!hasItemProducts && !hasAttributes)) {
      const filteredChoices = filterChoices(choices);
      if (targetItem.itemProduct) {
        heightOrWidthAttributes = addHeightOrWidthAttributes(targetItem.itemProduct.attributes);
      } else {
        heightOrWidthAttributes = addHeightOrWidthAttributes(targetItem.attributes);
      }

      payload = [...filteredChoices, ...heightOrWidthAttributes];
    } else {
      payload = choices.map(choice => ({
        C: choice.choiceId,
        O: choice.optionId,
        CV: choice.choiceValue,
      }));
    }
    const { configurationGuid } = sourceItem.itemProduct;

    try {
      const { canAddToCart, productId, optionDetails } = await
      executeRules(configurationGuid, payload);
      if (canAddToCart) {
        const constraints = await productDimensions(productId);
        const { data } = constraints;
        // eslint-disable-next-line no-restricted-syntax
        for (const detail of optionDetails) {
          if (detail.optionId === 1 || detail.optionId === 2) {
            const cvNumber = parseFloat(detail.cv);
            if (!isNaN(cvNumber)) {
              if (detail.optionId === 1 &&
                (cvNumber < data.MinHeight || cvNumber > data.MaxHeight)) {
                return false;
              } else if (detail.optionId === 2
                && (cvNumber < data.MinWidth || cvNumber > data.MaxWidth)) {
                return false;
              }
            } else {
              // eslint-disable-next-line no-console
              console.log('Invalid number for optionId:', detail.optionId);
            }
          }
        }
        const builtPayloadForPrice = buildPayloadForPrice(productId, optionDetails);
        const hasPricing = await
        hasProductPricing(builtPayloadForPrice);
        return hasPricing;
      }
      return false;
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error('Error executing rules to copy styles to target item', error);
      return false;
    }
  },
  errorMessage: (/* sourceItem, targetItem */) => (
    'Copied styles exceed product specifications'
  ),
  copyStylesError: true,
};

export default dimensions;
